import { Box } from "@mui/material"
import BaseModal from "../../../../../../components/modal/baseModal"
import { EvidencesTypeValueEnum } from "../../../../../../utils/enums/evidences"
import { FileModalProps } from "./type"
import { useStyles } from "./styles"

function FileModal({ type, src, modalProps }: FileModalProps) {
    const styles = useStyles()
    const isVideo = type == EvidencesTypeValueEnum.VIDEO
    const isImage = type == EvidencesTypeValueEnum.IMAGE
    const isDocument = type == EvidencesTypeValueEnum.DOCUMENT

    return (
        <BaseModal {...modalProps} open={!!modalProps?.open} sx={{ width: isDocument ? "80vw" : "600px", ...isDocument && ({ height: '80vh' }), ...isVideo && ({ height: '400px' }) }}>
            <Box sx={styles.container}>
                {
                    isVideo && (
                        <video controls style={{ width: "100%", height: "100%", objectFit: "contain" }}>
                            <source src={src} type="video/mp4" />
                        </video>
                    )
                }

                {
                    isImage && (
                        <img src={src} alt="" />
                    )
                }

                {isDocument && (
                    <iframe
                        src={src}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                        }}
                        title="document-viewer"
                    />
                )}
            </Box>
        </BaseModal>
    )
}

export { FileModal }
